import { FC, PropsWithChildren } from "react";
import Header from "../../auth/layout/Header";

export const Page: FC<PropsWithChildren<unknown>> = ({ children }) => (
  <div className="flex flex-col justify-start min-h-[inherit]">
    <Header home="travel" />
    <main className="mb-6">{children}</main>
  </div>
);
